module.exports = __webpack_public_path__ + "media/svg/bb-f1866cb5.svg";